<template>
    <div class="p-login" style="height: 100%;">
        <div class="pcStyle-register">
            <Header :showNav="false"/>
            <div class="p-sc-register">
                <div class="p-sc-register__title">欢迎注册智慧城市云网账号</div>
                <div class="p-sc-register__container">
                    <div class="p-sc-register__container__title">
                        <span>已有账号?</span><span @click="onLogin" class="right">立即登录</span>
                    </div>
                    <div class="p-sc-register__container__item">
                        <input v-model="account" type="tel" maxlength="11" placeholder="请输入手机号">
                    </div>
                    <div class="p-sc-register__container__item">
                        <input v-model="password" type="password" maxlength="16" placeholder="密码由字母和数字组合,长度控制在8-16位">
                    </div>
                    <div class="p-sc-register__container__item">
                        <input v-model="confirmpassword" type="password" maxlength="16" placeholder="确认密码">
                    </div>
                    <!-- <div class="p-sc-register__container__item">
                        <input v-model="mobile" type=" tel" placeholder="手机号">
                    </div> -->
                    <div class="p-sc-register__container__item">
                        <input v-model="verifycode" class="msg-code" type=" tel" placeholder="验证码">
                        <!-- <span class="msg-btn">获取验证码</span> -->
                        <span @click="getMsgCode" :class="{'msg-btn--grey': msgcodeSending}" class="msg-btn">{{msgbtnText}}</span>
                    </div>
                    <div class="p-sc-register__container__item">
                        <div class="protocol">
                            <input style="width: auto;" id="protocol" type="checkbox" @click="readProto"><label for="protocol">我已经阅读并接受以下协议</label>
                        </div>
                        <div class="protocol-content">
                          <a href="http://www.yunsmartcity.com/smartcity-files/login_xieyi.html" target="_blank">《智慧城市云网用户登录协议》</a>
                          <a href="http://www.yunsmartcity.com/smartcity-files/register_xieyi.html" target="_blank">《智慧城市云网用户注册协议》</a>
                            <!-- <span></span><span>《智慧城市云网登录服务协议》</span> -->
                        </div>
                    </div>
                    <div class="p-sc-register__container__item">
                        <span @click="onRegister" class="register-btn">注册</span>
                    </div>
                </div>
            </div>
            <Footer />
        </div>

        <div class="h5Style-register">
            <div class="p-sc-register">
                <div class="p-login_h5__logo">
                    <img src="../assets/login/logo.svg" alt="">
                </div>
                <!-- <div class="p-sc-register__title">欢迎注册智慧城市云网账号</div> -->
                <div class="p-sc-register__container">
                    <div class="p-sc-register__container__title">
                        <span>已有账号?</span><span @click="onLogin" class="right">立即登录</span>
                    </div>
                    <div class="p-sc-register__container__item">
                        <input v-model="account" type="text" maxlength="11" placeholder="请输入手机号">
                    </div>
                    <div class="p-sc-register__container__item">
                        <input v-model="password" type="password" maxlength="16" placeholder="密码由字母和数字组合,长度控制在8-16位">
                    </div>
                    <div class="p-sc-register__container__item">
                        <input v-model="confirmpassword" type="password" maxlength="16" placeholder="确认密码">
                    </div>
                    <!-- <div class="p-sc-register__container__item">
                        <input v-model="mobile" type=" tel" placeholder="手机号">
                    </div> -->
                    <div class="p-sc-register__container__item" style="display: flex;">
                        <input v-model="verifycode" class="msg-code" type=" tel" placeholder="验证码">
                        <!-- <span class="msg-btn">获取验证码</span> -->
                        <span @click="getMsgCode" :class="{'msg-btn--grey': msgcodeSending}" class="msg-btn">{{msgbtnText}}</span>
                    </div>
                    <div class="p-sc-register__container__item">
                        <div class="protocol">
                            <input style="width: auto;" id="protocol" type="checkbox" @click="readProto"><label for="protocol">我已经阅读并接受以下协议</label>
                        </div>
                        <div class="protocol-content">
                            <!-- <span>《智慧城市云网用户注册协议》</span><span>《智慧城市云网登录服务协议》</span> -->
                            <a href="http://www.yunsmartcity.com/smartcity-files/login_xieyi.html" target="_blank">《智慧城市云网用户登录协议》</a>
                            <a href="http://www.yunsmartcity.com/smartcity-files/register_xieyi.html" target="_blank">《智慧城市云网用户注册协议》</a>
                        </div>
                    </div>
                    <div class="p-sc-register__container__item">
                        <span @click="onRegister" class="register-btn">注册</span>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import { validMobile,validPassword } from '@/utils/validTools.js'
import './Home.css';
 import {setToken} from '@/utils/auth.js'
import {
    queryVerifycode,
    registerwithpwdApi,
    wxBindwxApi,
    wxLoginApi,
} from '@/api/login';

export default {
    name: 'Findpass',
    data() {
        return {
            type: 1, // 1：用户名，密码登录；2: 短信验证码； 3：微信扫码
            msgcodeSending: false,
            msgbtnText: '获取验证码',
            count: 0,
            verifycode: '',
            confirmpassword: '',
            password: '',
            account: '',
            isread:false
        }
    },
    components: {
        Header,
        Footer
    },
    methods: {
        changeLoginType(t) {
            this.type = t
        },
        onLogin() {
            this.$router.push('/login');
        },
        getMsgCode() {
            if (this.msgcodeSending) {
                return;
            }
            const mobile = this.account;
            if (!mobile) {
                this.$message.error('请输入手机号');
                return;
            }
            this.msgcodeSending = true;
            this.$http.get(queryVerifycode(), {
                mobile
            }).then(res => {
                this.msgbtnText = '60秒后重新获取';
                this.count = 60;
                this.countDown();
                console.log(res);
            }).catch(() => {
                this.msgcodeSending = false;
            })
        },
        countDown() {
            if (this.count > 0) {
                setTimeout(() => {
                    this.count -= 1;
                    this.msgbtnText = `${this.count}秒后重新获取`;
                    this.countDown();
                }, 1000)
            } else {
                this.msgcodeSending = false;
                this.msgbtnText = '获取验证码';
            }
        },
        readProto(e){
          this.isread = e.target.checked;
          console.log(e.target.checked)
        },
        onRegister() {
            if (!this.account) {
                this.$message.error('请输入手机号');
                return;
            }
            if(!validMobile(this.account)){
              this.$message.error('请输入正确的手机号');
              return;
            }
            if (!this.password) {
                this.$message.error('请输入密码');
                return;
            }
            if(!validPassword(this.password)){
              this.$message.error('密码由字母和数字组合,长度控制在8-16位');
              return;
            }
            if (!this.confirmpassword) {
                this.$message.error('请输入确认密码');
                return;
            }
            if(this.password!=this.confirmpassword){
                this.$message.error('两次输入的密码不一样');
                return;
            }
            if (!this.verifycode) {
                this.$message.error('请输入短信验证码');
                return;
            }
            if(!this.isread){
              this.$message.error('请阅读并接受以下协议');
              return;
            }
            this.$http.post(registerwithpwdApi(), {
                account: this.account,
                password: this.password,
                confirmpassword: this.confirmpassword,
                mobile: this.mobile,
                verifycode: this.verifycode
            }).then(res => {
                console.log('注册', res);
                if (res.code === 1) {
                    this.$message.success('注册成功');
                    this.loginSuccess(res.data);
                    return;
                }
                this.$message.error(res.msg || '服务器错误');
            }, err => {

            });
        },
        loginSuccess(userInfo) {
          setToken(userInfo.oauth)
          window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.$router.push('/');
        },
    }
}
</script>

<style scoped>

body.h5Style .p-login {
    background: #FAFAFB;
}
.p-login_h5__logo {
    text-align: center;
    padding-top: 100px;
}
.p-login_h5__logo img {
    margin-left: -20px;
}
.p-sc-register {
    /* margin: .4rem 0; */
    min-height: calc(100% - 1.34rem);
}
.p-sc-register__title {
    width: 100%;
    text-align: center;
    font-size: 30px;
    padding-top: .3rem;
}
.p-sc-register__container {
    padding: .67rem 1.46rem .5rem 1.46rem;
    width: 6.92rem;
    min-height: 4.55rem;
    box-sizing: border-box;
    margin: .4rem auto;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.12);
}
body.h5Style .p-sc-register__container {
    background: none;
}
.p-sc-register__container__title {
    text-align: right;
    font-size: 12px;
}
.p-sc-register__container__title .right {
    color: #1775F0;
    margin-left: 10px;
    cursor: pointer;
}
.p-sc-register__container__item {
    width: 4rem;
    margin-top: .2rem;
}

.p-sc-register__container__item input {
    width: 100%;
    padding: 6px 16px;
    border: 1px solid #979797;
    box-sizing: border-box;
}
.p-sc-register__container__item input.msg-code {
    width: 2.21rem;
}
.p-sc-register__container__item .msg-btn {
    width: 1.68rem;
    background-color: #1775F0;
    color: #fff;
    display: inline-block;
    text-align: center;
    height: .36rem;
    line-height: .36rem;
    margin-left: .1rem;
    cursor: pointer;
}

.p-sc-register__container__item .msg-btn.msg-btn--grey {
    background-color: #ccc;
}
.p-sc-register__container__item .protocol {
    height: .22rem;
    line-height: .22rem;
}
.p-sc-register__container__item .protocol input, .p-sc-register__container__item .protocol label {
    vertical-align: middle;
}
.p-sc-register__container__item .protocol label {
    margin-left: .1rem;
}
.protocol-content {
    margin-top: .06rem;
    color: #1775F0;
}
.protocol-content span {
    cursor: pointer;
}
.register-btn {
    height: .4rem;
    line-height: .4rem;
    width: 100%;
    background-color: #1775F0;
    color: #fff;
    text-align: center;
    display: inline-block;
    cursor: pointer;
}

body.pcStyle .h5Style-register,
body.h5Style .pcStyle-register {
    display: none;
}

body.h5Style .p-sc-register {
    margin: 0;
    min-height: none;
}
body.h5Style .p-sc-register__container {
    padding: 0 .62rem;
    width: 100%;
    box-shadow: none;
}
body.h5Style .p-sc-register__container__item {
    width: 100%;
    margin-top: .4rem;
}

body.h5Style .register-btn {
    height: .62rem;
    line-height: .62rem;
}

body.h5Style .p-sc-register__container__item input.msg-code {
    width: 3.62rem;
    height: .64rem;
}
body.h5Style .p-sc-register__container__item .msg-btn {
    width: 2.63rem;
    height: .64rem;
    line-height: .64rem;
}
body.h5Style .p-sc-register__container__item .protocol input {
    width: .21rem !important;
    height: .21rem;
}
body.h5Style .protocol-content {
    margin-top: .34rem;
}
body.h5Style .p-sc-register__container__title {
    font-size: .24rem;
}
</style>
